export const FULFILLMENT_ERROR = "FULFILLMENT_ERROR";
export const GET_FULFILLMENT_CONTACT = "GET_FULFILLMENT_CONTACT";
export const EDIT_FULFILLMENT_SUCCESS = "EDIT_FULFILLMENT_SUCCESS";
export const GET_FULFILLMENT = "GET_FULFILLMENT";
